import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es una dieta?',
  a: 'No. Es un protocolo de reducción de inflamación. No te pide que cuentes calorías ni que te prives de nada para siempre.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Apenas confirmado el pago recibís un email automático con los 6 tomos y 6 bonos en PDF. Acceso en menos de 5 minutos.'
}, {
  q: '¿Necesito ingredientes raros o caros?',
  a: 'No. Todo de cualquier supermercado argentino. Costo estimado de la primera semana entre $8.000 y $15.000 ARS.'
}, {
  q: '¿La garantía es real?',
  a: 'Totalmente real. Escribís a soporte@impulsodigitalstore.com y te devolvemos el 100% sin preguntas.'
}, {
  q: '¿Funciona también para hombres?',
  a: 'Sí. El protocolo funciona igual para cualquier persona.'
}, {
  q: '¿Sirve si llevo años con el problema?',
  a: 'Sí. La inflamación crónica responde al protocolo independientemente del tiempo que lleves con el problema.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-black border-t border-white/5" data-id="element-88">
      <div className="max-w-3xl mx-auto" data-id="element-89">
        <div className="mb-12" data-id="element-90">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-white flex items-center justify-center gap-3" data-id="element-91">
            <span className="text-brand-lime" data-id="element-92">❓</span> LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-93">
          {faqs.map((faq, i) => <div key={i} className="bg-white/5 backdrop-blur-sm rounded-xl overflow-hidden border-l-4 border-brand-lime border-r border-t border-b border-white/10" data-id="element-94">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-95">
                <span className="font-bold text-lg text-white pr-4" data-id="element-96">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="shrink-0 text-brand-lime" data-id="element-97">
                  <ChevronDown size={24} data-id="element-98" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-99">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-100">
                    <div className="px-6 pb-6 text-gray-300 leading-relaxed text-left" data-id="element-101">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}